type TitlesProps = {
    title: string,
    withBgPattern?: boolean,
    color?: string
}

const Titles = ({ title, withBgPattern = true, color = 'text-primary-10' }: TitlesProps) => {
    return (
        <div>
            <h2 className={`flex items-center text-hmedium md:text-dsmall ${color}  w-full sm:w-max ${withBgPattern ? ' bg-title-pattern bg-no-repeat bg-contain w-[9.375rem] h-[4.313rem] pl-4' : ''}`}>
                {title}
            </h2>
        </div >
    )
}

export default Titles